import { removeDuplicates } from "@taabl/common-lib/utils";
import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import config from "../config";
import { Constants } from "../libs/Constants";
import { create } from "../libs/dbFunctions";
import OpenPlaidLink from "./OpenPlaidLink";
import PageLoader from "./PageLoader";

const configObj = config.getConfigObject();

const dwolla = window.dwolla;
const BankAccount = ({ userObj, title, ...props }) => {
  const [view, setView] = useState(null);
  const [token, setToken] = useState(null);
  const [customerId, setCustomerId] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (configObj.bank_integration === "dwolla") {
      dwolla.configure({
        environment: configObj.dwolla.environment,
        styles: "/styles/update-custom.css",
        token: () => {
          const dwollaURL = configObj.dwolla.baseUrl;
          console.log("getting the dwolla url:" + dwollaURL);
          return create(Constants.dbTypes.PAYMENT_TOKEN, {
            type: Constants.dbTypes.PAYMENT_TOKEN,
            tokenType: "client-tokens",
            action: "customer.create",
            _links: {
              customer: {
                href: `${dwollaURL}/customers/${userObj.id}`,
              },
            },
          });
        },
        success: (res) => onSuccess(res),
        error: (err) => Promise.resolve(err),
      });
      setView("account");
    } else {
      setView("plaid");
    }
    if (userObj.dwolla_customer_id) {
      setCustomerId(userObj.dwolla_customer_id);
    }
  }, [userObj]);

  useEffect(() => {
    function renderView() {
      if (view === "account" && customerId && props?.show) {
        createDwollaBankAccount();
      }
      if (view === "plaid" && customerId) {
        createLinkToken();
        createPlaidBankAccount();
      }
    }
    renderView();
  }, [view, customerId, props?.show]);

  async function createLinkToken() {
    let response = await create(Constants.dbTypes.PAYMENT_TOKEN, {
      type: Constants.dbTypes.PAYMENT_TOKEN,
      tokenType: Constants.dbTypes.PLAID_TOKEN,
    });
    setToken(response);
  }

  const createDwollaBankAccount = async () => {
    setLoading(true);
    // Get token
    let tokenResponse = await create(Constants.dbTypes.PAYMENT_TOKEN, {
      type: Constants.dbTypes.PAYMENT_TOKEN,
      tokenType: "iav-token",
      customer: customerId,
    });
    setLoading(false);
    if (tokenResponse && tokenResponse.token) {
      dwolla.iav.start(
        tokenResponse.token,
        {
          container: "iavContainer",
          stylesheets: [
            "https://fonts.googleapis.com/css?family=Lato&subset=latin,latin-ext",
          ],
          microDeposits: "true",
          fallbackToMicroDeposits: "true",
          backButton: "true",
        },
        function(err, res) {
          console.log(
            "Error: " +
              JSON.stringify(err) +
              " -- Response: " +
              JSON.stringify(res)
          );
          if (err) {
            let error = getError(err);
            props.onHide(false, error);
          }
          if (!err) {
            props.onHide(true, res);
          }
        }
      );
    }
  };
  const getError = (e) => {
    if (e && e.status !== 200) {
      if (
        "body" in e &&
        e.body &&
        "_embedded" in e.body &&
        e.body["_embedded"] &&
        "errors" in e.body["_embedded"] &&
        e.body["_embedded"]["errors"] &&
        e.body["_embedded"]["errors"].length > 0
      ) {
        // Remove the duplicate errors if any
        const errors = [...e.body["_embedded"]["errors"]];
        const uniqueErrors = removeDuplicates(errors, "message");
        const error = uniqueErrors.map((er) => er.message).join(" ");
        return error;
      }
      if (
        "body" in e &&
        e.body &&
        "code" in e.body &&
        e.body.code &&
        e.body.code === "InvalidResourceState"
      ) {
        return e.body.message;
      }
    }
    return "Error occured while adding your bank account.";
  };
  const createPlaidBankAccount = async () => {
    setLoading(true);
    // Get token
    let tokenResponse = await create(Constants.dbTypes.PAYMENT_TOKEN, {
      type: Constants.dbTypes.PAYMENT_TOKEN,
      tokenType: "iav-token",
      customer: customerId,
    });
    setLoading(false);
    if (tokenResponse && tokenResponse.token) {
      dwolla.iav.start(
        tokenResponse.token,
        {
          container: "iavContainer",
          stylesheets: [
            "https://fonts.googleapis.com/css?family=Lato&subset=latin,latin-ext",
          ],
          microDeposits: "true",
          fallbackToMicroDeposits: "true",
          backButton: "true",
        },
        function(err, res) {
          console.log(
            "Error: " +
              JSON.stringify(err) +
              " -- Response: " +
              JSON.stringify(res)
          );
          if (!err) {
            props.onHide(true, res);
          }
        }
      );
    }
  };

  const onSuccess = (response) => {
    props.onHide(true, response);
  };
  const handleExit = () => {
    props.onHide(true);
  };
  const renderDwollaAddAccount = () => {
    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="contribution-modal"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {title || "Add Bank Account"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <PageLoader isActive={loading}>{renderBankAccountIAV()}</PageLoader>
        </Modal.Body>
      </Modal>
    );
  };
  const renderBankAccountIAV = () => {
    return (
      <>
        <div id="iavContainer"></div>
      </>
    );
  };
  const renderPlaidAddAccount = () => {
    if (loading || !token) {
      return (
        <PageLoader isActive={loading}>
          <>Loading...</>
        </PageLoader>
      );
    }
    return (
      <OpenPlaidLink
        token={token}
        onSuccess={(response) => onSuccess(response)}
        onExit={handleExit}
      />
    );
  };
  if (view === "account") {
    return renderDwollaAddAccount();
  }
  return renderPlaidAddAccount();
};

export default BankAccount;
